// extracted by mini-css-extract-plugin
module.exports = {"container":"FeedbackForm__container","serverError":"FeedbackForm__serverError"};